import { useClaimPromoCode } from "./useClaimPromoCode";

export function ClaimPromoCode() {
  useClaimPromoCode();
  return null;
}
